import { render } from "./CvCard011.vue?vue&type=template&id=01ce6628&scoped=true"
import script from "./CvCard011.vue?vue&type=script&lang=js"
export * from "./CvCard011.vue?vue&type=script&lang=js"

import "./CvCard011.vue?vue&type=style&index=0&id=01ce6628&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-01ce6628"]])

export default __exports__